<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteInventoryConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("inventories.sku_placeholder")' :danger="!$v.newRecord.sku" :danger-text="'sku is required'" v-model="newRecord.sku" :label='$t("inventories.sku")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("inventories.product_placeholder")' :danger="!$v.newRecord.product" :danger-text="'product is required'" v-model="newRecord.product" :label='$t("inventories.product")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("inventories.quantity_placeholder")' :danger="!$v.newRecord.quantity.numeric" :danger-text="'quantity is required'" v-model="newRecord.quantity" :label='$t("inventories.quantity")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("inventories.unit_price_placeholder")' :danger="!$v.newRecord.unit_price.numeric" :danger-text="'unit_price is required'" v-model="newRecord.unit_price" :label='$t("inventories.unit_price")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("inventories.unit_measurement_placeholder")' :danger="!$v.newRecord.unit_measurement" :danger-text="'unit_measurement is required'" v-model="newRecord.unit_measurement" :label='$t("inventories.unit_measurement")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
</template>
<script>
import { required, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Inventories')

export default {
  name: 'ModalInventories',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      sku: {
        required
      },
      product: {
        required
      },
      quantity: {
        required,
        numeric
      },
      unit_price: {
        required,
        numeric
      },
      unit_measurement: {
        required
      }
    }
  },
  async created () {
    this.getCatalog()
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'inventoriesCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('inventories.add') : this.$t('inventories.edit')
    }
  },
  methods: {
    ...mapActions([
      'addInventory',
      'editInventory',
      'deleteInventory',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addInventory(this.newRecord) : this.editInventory(this.newRecord)
    },
    async deleteInventoryConfirm (inventory) {
      let t = this
      this.auxDeleteInventory = () => {
        t.deleteInventory(inventory)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(inventory.sku) }),
        accept: this.auxDeleteInventory
      })
    },
    async getCatalog () {
      Object.keys(this.inventoriesCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
